export const REGISTER_THERMOSTAT_UPDATE = 'REGISTER_THERMOSTAT_UPDATE'
export const REGISTER_THERMOSTAT_ADD = 'REGISTER_THERMOSTAT_ADD'
export const REGISTER_THERMOSTAT_REQUEST = 'REGISTER_THERMOSTAT_REQUEST'
export const REGISTER_THERMOSTAT_SUCCESS = 'REGISTER_THERMOSTAT_SUCCESS'
export const REGISTER_THERMOSTAT_ERROR = 'REGISTER_THERMOSTAT_ERROR'
export const RESET_REGISTER_THERMOSTAT = 'RESET_REGISTER_THERMOSTAT'
export const REGISTER_THERMOSTAT_UPDATE_ALL = 'REGISTER_THERMOSTAT_UPDATE_ALL'
export const REGISTER_THERMOSTAT_SET_DUPLICATES =
	'REGISTER_THERMOSTAT_SET_DUPLICATES'
